import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "overflow-menu"

  show() {
    const items = this.menuItems

    if (items.length > 0) {
      this.send("display", { items }, ({ index }) => {
        const selected = items[index]
        if (selected?.url) {
          window.location.href = selected.url
        }
      })
    }
  }

  get menuItems() {
    const itemElements = this.element.querySelectorAll("[data-bridge-overflow-menu-item]")
    return Array.from(itemElements).map((el) => ({
      title: el.textContent.trim(),
      url: el.href || el.dataset.url
    }))
  }
}
